import React from 'react';
import { observer, inject } from 'mobx-react'

const UnreadMessagesBadge = ({store, children}) => {
  const unread = store.visibleConversations.reduce((total, c) => total + c.unreadByMeCount, 0)
  return (
    <div className="urnread-messages-container">
      {children}
      {unread > 0 && <span className="unread-badge">{unread}</span>}
    </div>
  );
};

export default inject('store')(observer(UnreadMessagesBadge));